// Declare translations globally
let uploadtranslations = {
  en: {
    requiredFields: "Please fill in all required(*) fields",
    uploadPrescription: "Please upload a prescription file",
    validFullName: "Please enter a valid full name (minimum 2 characters)",
    validPhoneNumber: "Please enter a valid 8-digit phone number [eg: 31234567].",
    validEmailAddress: "Please enter a valid email address.",
    selectArea: "Please select an area.",
    uploadInsuranceCard: "Please upload an insurance card.",
    uploadClaimFile: "Please upload a claim file.",
    uploadQatarID: "Please upload a Qatar ID.",
  },
  ar: {
    requiredFields: "يرجى ملء جميع الحقول المطلوبة (*)",
    uploadPrescription: "يرجى تحميل ملف الوصفة الطبية",
    validFullName: "يرجى إدخال اسم كامل صالح (حد أدنى حرفان)",
    validPhoneNumber: "يرجى إدخال رقم هاتف صالح مكون من 8 أرقام [مثال: 31234567].",
    validEmailAddress: "يرجى إدخال عنوان بريد إلكتروني صالح.",
    selectArea: "يرجى اختيار منطقة.",
    uploadInsuranceCard: "يرجى تحميل بطاقة التأمين.",
    uploadClaimFile: "يرجى تحميل ملف المطالبة.",
    uploadQatarID: "يرجى تحميل بطاقة الهوية القطرية.",
  },
};

// Ensure script runs when DOM is fully loaded
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", onPageLoad);
} else {
  onPageLoad();
}
// Wait for the DOM to load before adding the event listener
function onPageLoad() {
  // Form Validation
  const successMessage = document.getElementById("success");
  const errorMessage = document.getElementById("error");
  errorMessage.textContent = ""; // Clear any previous error messages

  // Required Fields
  const fullNameInput = document.getElementById("ContactForm-name");
  const phoneInput = document.getElementById("ContactForm-phone");
  const emailInput = document.getElementById("ContactForm-email");
  const areaSelect = document.getElementById("AREA");
  const prescriptionInput = document.getElementById("ClaimFile1");
  const insuranceInput = document.getElementById("InsuranceCard");
  const claimFileInput = document.getElementById("ClaimFile");
  const qatarIDInput = document.getElementById("QatarID");
  const otherDocInput = document.getElementById("OtherDoc");
  const prescriptionButton = document.getElementById("prescriptionbtn");
  const currentLanguage = document.documentElement.lang || 'en'; 

  function showError(input, messageKey) {

    const message =(uploadtranslations[currentLanguage] && uploadtranslations[currentLanguage][messageKey])|| messageKey;
    input.classList.add("error-field");
    input.setAttribute("aria-invalid", "true");
    // Avoid duplicate error messages
    if (!input.parentNode.querySelector(".field-error")) {
      const errorSpan = document.createElement("span");
      errorSpan.className = "field-error";
      errorSpan.textContent = message;
      input.parentNode.appendChild(errorSpan);
      errorSpan.setAttribute("tabindex", "-1"); // Make it focusable
      errorSpan.focus();
      errorSpan.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }

  function clearError(input) {
    const errorSpan = input.parentNode.querySelector(".field-error");
    if (errorSpan) {
      errorSpan.remove();
    }
    input.classList.remove("error-field");
    input.setAttribute("aria-invalid", "false");
  }

  function clearErrors() {
    document.querySelectorAll(".error-field").forEach((field) => {
      field.classList.remove("error-field");
      field.setAttribute("aria-invalid", "false");
    });
  }

  function validateName(name) {
    return name.trim().length >= 2;
  }

  function validatePhone(phoneNumber) {
   if (/^\+974[3567][0-9]{7}$/.test(phoneNumber)) {
      // Remove the +974 prefix and return the 8-digit number
      phoneNumber = phoneNumber.replace(/^\+974/, '');
    }
  
    // If no +974 prefix, validate as an 8-digit number
    if (/^[3567][0-9]{7}$/.test(phoneNumber)) {
      return phoneNumber; // Return the 8-digit number as it is valid
    }
  
    // If neither condition is met, return false
    return false; // Invalid number
  }

  function validateEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  function validateFile(input) {
    return input.files.length > 0;
  }

  function getSelectedRadioId(groupName) {
    const selectedRadio = document.querySelector(
      `input[name="${groupName}"]:checked`
    );
    return selectedRadio ? selectedRadio.value : null; // Return null if no radio button is selected
  }

  function validateForm() {
    clearErrors();
    let isValid = true;

    if (!validateName(fullNameInput.value)) {
      showError(
        fullNameInput,
        "validFullName"
      );
      isValid = false;
    }

    if (!validatePhone(phoneInput.value)) {
      showError(
        phoneInput,
        "validPhoneNumber"
      );
      isValid = false;
    }

    if (!validateEmail(emailInput.value)) {
      showError(emailInput, "validEmailAddress");
      isValid = false;
    }

    if (areaSelect.value === "") {
      showError(areaSelect, "selectArea");
      isValid = false;
    }

    if (!validateFile(prescriptionInput)) {
      showError(prescriptionInput, "uploadPrescription");
      isValid = false;
    }

    //Insurance File Validation
    const selectedId = getSelectedRadioId("contact[insurancepatient-group]");
    if (selectedId == 1) {
      if (!validateFile(insuranceInput)) {
        showError(insuranceInput, "uploadInsuranceCard");
        isValid = false;
      }
      if (!validateFile(claimFileInput)) {
        showError(claimFileInput, "uploadClaimFile");
        isValid = false;
      }
      if (!validateFile(qatarIDInput)) {
        showError(qatarIDInput, "uploadQatarID");
        isValid = false;
      }
    }

    return isValid;
  }

  fullNameInput.addEventListener("input", () => clearError(fullNameInput));
  phoneInput.addEventListener("input", () => clearError(phoneInput));
  emailInput.addEventListener("input", () => clearError(emailInput));
  areaSelect.addEventListener("change", () => clearError(areaSelect));
  prescriptionInput.addEventListener("change", () =>
    clearError(prescriptionInput)
  );
  insuranceInput.addEventListener("change", () => clearError(insuranceInput));
  claimFileInput.addEventListener("change", () => clearError(claimFileInput));
  qatarIDInput.addEventListener("change", () => clearError(qatarIDInput));
  otherDocInput.addEventListener("change", () => clearError(otherDocInput));

  if (prescriptionButton) {
    prescriptionButton.addEventListener("click", function () {
      const form = document.getElementById("ContactForm");
      form.classList.add("submitting");
      // Reuired field Validation
      const maxFileSize = 2 * 1024 * 1024; // 2 MB in bytes

      const mainPresc = document.getElementById("ClaimFile1").files;
      const optPresc = document.getElementById(
        "ContactForm-optional-file"
      ).files;
      const insuranceCard = document.getElementById("InsuranceCard").files;
      const claimFile = document.getElementById("ClaimFile").files;
      const qatarID = document.getElementById("QatarID").files;
      const otherDoc = document.getElementById("OtherDoc").files;

      // Validate each file type
      if (!validateFiles(mainPresc, maxFileSize, "Prescription 1")) return;
      if (!validateFiles(optPresc, maxFileSize, "Prescription 2")) return;
      if (!validateFiles(insuranceCard, maxFileSize, "Insurance Card")) return;
      if (!validateFiles(claimFile, maxFileSize, "Claim File")) return;
      if (!validateFiles(qatarID, maxFileSize, "Qatar ID")) return;
      if (!validateFiles(otherDoc, maxFileSize, "Other Document")) return;

      const formData = new FormData(form); // Use FormData to capture all form inputs including files

      // Log uploaded files

      const file1 = formData.get("contact[claim_file_1]");
      const file2 = formData.get("contact[optional_file]");
      const file3 = formData.get("contact[insurance_card]");
      const file4 = formData.get("contact[claim_file]");
      const file5 = formData.get("contact[qatar_id]");
      const file6 = formData.get("contact[other_doc]");

      formData.append("prescriptionFile1", file1);
      formData.append("prescriptionFile2", file2);
      // Insurance Files
      formData.append("insuranceCard", file3);
      formData.append("insuranceClaim", file4);
      formData.append("QatarId", file5);
      formData.append("otherDoc", file6);
      // Log radio button selection
      const insurancePatient = formData.get("contact[insurancepatient-group]");
      // Log area selection
      // Access the <select> element
      const selectElement = document.getElementById("AREA");
      // Get the label of the selected option
      const selectedArea = selectElement.options[selectElement.selectedIndex].text;
      formData.append("area", selectedArea);
      // Log notes
      const notes = formData.get("contact[notes]");
      const customerId = ShopifyAnalytics.meta.page.customerId;
      formData.append("customer_id", customerId);

      if (validateForm()) {
        fetch("https://app.rafpharmacy.com/api/prescription/post", {
          method: "POST",
          body: formData,
        })
          .then((response) => response.json()) // Parse the JSON response
            .then((data) => {
                console.log("Parsed response:", data);
                if (data.status === "success") {
                  console.log("Form submitted successfully:", data.message);
                  successMessage.textContent ="Form Submitted Successfully";
                  successMessage.style.display = "block";
                  errorMessage.style.display = "none";
                  const fileInputs = document.querySelectorAll('#ContactForm input[type="file"]');
                  const fileDisplaySpans = document.querySelectorAll("#ContactForm .file-names-display");
                  // Iterate through each file input and reset its value
                  fileInputs.forEach((fileInput) => {
                    fileInput.value = "";
                  });
                 // Iterate through each span displaying the file name and clear its text
                  fileDisplaySpans.forEach((span) => {
                    span.textContent = "No files selected"; // Reset displayed text
                  });
                // Reset the form
                form.reset();
               // Hide the success message after 5 seconds (5000ms)
                 setTimeout(() => {
                successMessage.style.display = "none";
              }, 5000);
            } else {
              console.log("Form submission failed:", data.message);
              errorMessage.textContent ="Form Submission Failed";
             successMessage.style.display = "none";
              errorMessage.style.display = "block";
            }
          })

          .catch((error) => {
            console.error("Error submitting form:", error);
             errorMessage.textContent= "There was an error submitting the form. Check the console for details.";
          });
      } else {
        successMessage.style.display = "none";
        errorMessage.style.display = "block";
      }
    });
  }
};

// Function to validate files
function validateFiles(files, maxSize, type) {
  for (const file of files) {
    if (file.size > maxSize) {
      document.getElementById("error").textContent = `A ${type} file "${
        file.name
      }" exceeds the size limit of ${maxSize / (1024 * 1024)} MB.`;
      return false;
    }
  }
  return true;
}
